var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "vModal vModalDefault",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "vModalDefaultHeader" },
        [
          _vm._t("header", function () {
            return [_vm._v("Default Header")]
          }),
          _c(
            "button",
            {
              staticClass: "vModalDefaultCloseButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("close")]
          ),
        ],
        2
      ),
      _vm._t("body", function () {
        return [_vm._v("Default Body")]
      }),
      _vm._t("footer", function () {
        return [
          _c("div", { staticClass: "vModalDefaultFooter" }, [
            _c(
              "button",
              {
                staticClass: "rbButton",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "button",
              { staticClass: "rbButton mainButton", attrs: { type: "submit" } },
              [_vm._v(_vm._s(_vm.options.labels.buttons.apply))]
            ),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }